/**
 * Checks if a string is a valid UUID format
 * @param str - The string to check
 * @returns True if the string is a valid UUID format
 */
export function isUUID(str: string): boolean {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}

/**
 * Checks if a string looks like it could be a slug (contains lowercase letters/numbers, may have hyphens)
 * @param str - The string to check
 * @returns True if the string looks like a slug
 */
export function looksLikeSlug(str: string): boolean {
  // Slugs contain lowercase letters, numbers, and optionally hyphens
  // They should not be UUIDs and should look like URL-friendly identifiers
  return /^[a-z0-9-]+$/.test(str) && str.length > 0;
}
